import { render, staticRenderFns } from "./works.vue?vue&type=template&id=5ec643a7&scoped=true"
import script from "./works.vue?vue&type=script&lang=ts"
export * from "./works.vue?vue&type=script&lang=ts"
import style0 from "./works.vue?vue&type=style&index=0&id=5ec643a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec643a7",
  null
  
)

export default component.exports